(function ($) {
  $('.product_slider .product-grid').flickity({
    imagesLoaded: true,
    groupCells: false,
    dragThreshold: 5,
    cellAlign: 'left',
    wrapAround: true,
    prevNextButtons: true,
    percentPosition: true,
    pageDots: false,
    rightToLeft: false,
    autoPlay: 5000
  });

  var $gallery = $('.product-single__gallery');
  var $thumbs = $('.product-single__thumbnails');

  if (!$gallery.length) return;

  var itemsCount = $gallery.find('.product-single__gallery-item').length;
  var isMobile = window.innerWidth <= 768;

  if (itemsCount > 1 || isMobile) {
    if ($gallery.data('flickity')) {
      $gallery.flickity('destroy');
    }

    if ($thumbs.length && $thumbs.data('flickity')) {
      $thumbs.flickity('destroy');
    }

    $gallery.flickity({
      imagesLoaded: true,
      groupCells: false,
      dragThreshold: 5,
      cellAlign: isMobile ? 'center' : 'left',
      wrapAround: true,
      prevNextButtons: true,
      pageDots: true,
      percentPosition: true,
      rightToLeft: false,
      autoPlay: false,
      adaptiveHeight: false
    });

    if ($thumbs.length) {
      $thumbs.flickity({
        cellSelector: 'li',
        imagesLoaded: true,
        contain: true,
        groupCells: false,
        cellAlign: 'left',
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        freeScroll: false,
        wrapAround: false,
        asNavFor: '.product-single__gallery'
      });

      var $thumbItems = $thumbs.find('li');

      $thumbItems.removeClass('active');
      $thumbItems.first().addClass('active');

      $gallery
        .off('change.productGallery')
        .on('change.productGallery', function (event, index) {
          $thumbItems.removeClass('active');
          $thumbItems.eq(index).addClass('active');

          if ($thumbs.data('flickity')) {
            $thumbs.flickity('select', index);
          }
        });

      $thumbs
        .off('click.productGalleryThumb', 'li')
        .on('click.productGalleryThumb', 'li', function (e) {
          e.preventDefault();

          var index = $(this).index();

          $gallery.flickity('select', index);
        });
    }

    $('.product__thumb-arrow--next')
      .off('click.productThumb')
      .on('click.productThumb', function (e) {
        e.preventDefault();

        $gallery.flickity('next');
      });

    $('.product__thumb-arrow--prev')
      .off('click.productThumbPrev')
      .on('click.productThumbPrev', function (e) {
        e.preventDefault();

        $gallery.flickity('previous');
      });
  }
})(jQuery);